export const formatExportDateAndTime = (currentDate: Date): string => {
  const splitDate = currentDate.toISOString().split('T');
  const date = splitDate[0];
  const time = splitDate[1].replace('Z', '');

  return `${date}T_${time}`;
};
